import { useEffect, useState } from "react"
import { CopyToClipboard } from "react-copy-to-clipboard"

const CopyIcon = ({ value }) => {
  const [copiedValue, setCopiedValue] = useState(false)

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (copiedValue) setCopiedValue(false)
    }, 2000)

    return () => clearTimeout(timeout)
  }, [copiedValue])
  return (
    <CopyToClipboard text={value} onCopy={() => setCopiedValue(true)}>
      <span
        className="material-icons-round p-1.5 hover:cursor-pointer hover:bg-gray-200 rounded-full"
        title="Copy to clipboard"
      >
        {copiedValue ? "done" : "content_copy"}
      </span>
    </CopyToClipboard>
  )
}

export default CopyIcon
